import { TFunction } from 'i18next';

export interface UserGuideModule {
  key: string;
  title: string;
  description: string;
}

export const userGuideModules = (t: TFunction, tourGuideEnabled: boolean): UserGuideModule[] => {
  const modules: UserGuideModule[] = [
    {
      key: 'dashboard',
      title: t('user_guide_module_dashboard_title'),
      description: t('user_guide_module_dashboard_description'),
    },
    {
      key: 'ai_assistance',
      title: t('user_guide_module_ai_assistance_title'),
      description: t('user_guide_module_ai_assistance_description'),
    },
    {
      key: 'analytics',
      title: t('user_guide_module_analytics_title'),
      description: t('user_guide_module_analytics_description'),
    },
    {
      key: 'contacts',
      title: t('user_guide_module_contacts_title'),
      description: t('user_guide_module_contacts_description'),
    },
    {
      key: 'bulk_messaging',
      title: t('user_guide_module_bulk_messaging_title'),
      description: t('user_guide_module_bulk_messaging_description'),
    },
    {
      key: 'power_dialer',
      title: t('user_guide_module_power_dialer_title'),
      description: t('user_guide_module_power_dialer_description'),
    },
    {
      key: 'settings',
      title: t('user_guide_module_settings_title'),
      description: t('user_guide_module_settings_description'),
    },
    {
      key: 'load_wallet',
      title: t('user_guide_module_load_wallet_title'),
      description: t('user_guide_module_load_wallet_description'),
    },
    {
      key: 'purchase_number',
      title: t('user_guide_module_purchase_number_title'),
      description: t('user_guide_module_purchase_number_description'),
    },
    {
      key: 'invite_members',
      title: t('user_guide_module_invite_members_title'),
      description: t('user_guide_module_invite_members_description'),
    },
    {
      key: 'add_call_setting',
      title: t('user_guide_module_add_call_setting_title'),
      description: t('user_guide_module_add_call_setting_description'),
    },
    {
      key: 'add_payment_method',
      title: t('user_guide_module_add_payment_method_title'),
      description: t('user_guide_module_add_payment_method_description'),
    },
    {
      key: 'user_guide',
      title: t('user_guide_module_user_guide_title'),
      description: t('user_guide_module_user_guide_description'),
    },
  ];

  return modules.filter((module) => tourGuideEnabled || module.key !== 'user_guide');
};
